import { CheckboxGroup } from '@madpaws/design-system';
import { useField } from 'formik';

import type { CheckboxGroupOnChange } from '@madpaws/design-system';
// TODO (WEB-81) fix import when prop types will be exported
import type { Props as CheckboxProps } from '@madpaws/design-system/dist/components/CheckboxGroup/CheckboxGroup';
import type { ReactElement } from 'react';

type Props = Omit<CheckboxProps, 'onChange' | 'value'>;

const CheckboxGroupField = ({ name, options, ...rest }: Props): ReactElement => {
  const [{ value }, {}, { setValue }] = useField(name);

  const onChange = ({ target }: CheckboxGroupOnChange): void => {
    setValue(target.value.value);
  };

  return (
    <CheckboxGroup name={name} onChange={onChange} options={options} value={{ value }} {...rest} />
  );
};

export { CheckboxGroupField };
